'use client';

import { __styles } from "@griffel/react";
import { typographyStyles } from "@fluentui/react-theme";
export const caption2ClassNames = {
  root: 'fui-Caption2'
};
/**
 * Styles for the root slot
 */
export const useCaption2Styles = /*#__PURE__*/__styles({
  root: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "f13mqy1h",
    Bhrd7zp: "figsok6",
    Bg96gwp: "fcpl73t"
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".f13mqy1h{font-size:var(--fontSizeBase100);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".fcpl73t{line-height:var(--lineHeightBase100);}"]
});